export const cookies = document.cookie.split(';').reduce((acc, cur) => {
    const [key, value] = cur.trim().split('=');
    return { ...acc, [key]: value };
}, {});
